import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import Invoice from "./invoice";
import {setWorkspaceGraphInvoices, upsertWorkspaceInvoice, workspaceGraphSelectors} from "../../system/workspace-graph-slice";

export function useInvoice() {
    const dispatch = useDispatch();
    const invoices = useSelector(workspaceGraphSelectors.invoices);
    const getInvoices = useCallback(async (workspaceId) => {
        if (!workspaceId) return [];
        const model = new Invoice();
        const data = await model.getAll({
            populate: "*",
            sort: ["issuedAt:desc", "createdAt:desc"],
            pagination: {pageSize: 20},
        });
        const items = data?.data || [];
        dispatch(setWorkspaceGraphInvoices(items));
        return items;
    }, [dispatch]);
    const getInvoice = useCallback(async (documentId) => {
        const model = new Invoice();
        const data = await model.getById(documentId);
        if (data?.data) dispatch(upsertWorkspaceInvoice(data.data));
        return data?.data;
    }, [dispatch]);
    const downloadInvoicePdf = useCallback(async (documentId, workspaceDocumentId) => {
        const model = new Invoice();
        return model.downloadPdf(documentId, workspaceDocumentId);
    }, []);
    return {invoices, getInvoices, getInvoice, downloadInvoicePdf};
}
